export class SportPushesRetriever {
    constructor(sportsMapper, countMapper, sportDataGateway) {
        this.sportsMapper = sportsMapper;
        this.countMapper = countMapper;
        this.sportDataGateway = sportDataGateway;
        this.sportsSubscription = { unsubscribe: () => { } };
    }
    subscribe(state, queryFactory) {
        const queryInfo = queryFactory((message) => this.updateSports(state, message.data));
        this.sportsSubscription = this.sportDataGateway.subscribeForSports(queryInfo);
    }
    unsubscribe() {
        this.sportsSubscription.unsubscribe();
    }
    updateSports(state, data) {
        if (data.add.length > 0) {
            const added = this.sportsMapper.mapFromPushes(data.add);
            state.replaceItems(state.Items.concat(added));
        }
        if (data.remove.length > 0) {
            data.remove.forEach(id => state.remove(id));
        }
        if (data.change.length > 0) {
            data.change.forEach(c => this.updateSportInState(state, c));
        }
    }
    updateSportInState(state, sportChange) {
        const numberOfEvents = this.countMapper(sportChange);
        if (numberOfEvents > 0) {
            state.update(sportChange.id, { numberOfEvents });
        }
        else {
            state.remove(sportChange.id);
        }
    }
}
//# sourceMappingURL=SportPushesRetriever.js.map